var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['status-icon', 'status-' + _vm.colorScheme]},[_c('div',[_c('span',{staticClass:"material-icons",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.icon))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }